import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import createSagaMiddleware from 'redux-saga';

import rootSaga from './sagas';
import rootReducer from './slices';

const sagaMiddleware = createSagaMiddleware();

const historyApi = createBrowserHistory();

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer
} = createReduxHistoryContext({
  history: historyApi,
  oldLocationChangePayload: true,
  savePreviousLocations: 2
});

const middleware = [
  ...getDefaultMiddleware({ thunk: false }),
  sagaMiddleware,
  routerMiddleware
];

export const getConfigCreateStore = () =>
  fetch('/config.json')
    .then(res => res.json())
    .then(config => {
      const store = configureStore({
        reducer: {
          router: routerReducer,
          ...rootReducer
        },
        middleware,
        devTools: !(config?.ENV === 'PROD')
      });

      sagaMiddleware.run(rootSaga);
      const history = createReduxHistory(store);
      return { store, history, config };
    });
